import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnDestroy, OnInit, ViewChild, ViewChildren, ElementRef, QueryList } from '@angular/core';
import { MatSort, SortDirection } from '@angular/material/sort';
import { MatLegacyRow as MatRow, MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { interval, Subject, Subscription, timer } from 'rxjs';
import { ClientContextService, CommonBrowserStorageService, ConfigurationService, ContextChange, HttpService, WidgetStyle } from '@sdbn/appclient';
import { DateUtilsService, TranslationService } from '@sdbn/common';
import { environment } from 'src/environments/environment';
import { TransportCounts, TransportScope, TransportSelection, TransportStatus, TransportTaskStatus, TransportType } from "src/tmc-yard/common/model/transport.model";
import { AbstractWidgetComponent } from '@sdbn/appclient';
import { Transport } from 'src/tmc-yard/common/model/transport.model';
import { TransportDetailsLayoutConverter } from 'src/tmc-yard/common/components/tmp/transport-details-layout-converter.service';
import { TransportIdentity } from '../../model';
import { TmcContextService } from 'src/tmc-common/services/tmc-context.service';
import { TMCClientParameters } from 'src/tmc-common/tmc-client-parameters';
import { CustomFilter } from 'src/tmc-common/model/custom-filter';
import { debounceTime, switchMap, tap } from 'rxjs/operators';
import { SortDefinition } from 'src/tmc-yard/common/components/transport-list/transport-list.model';
import { getTransportDetailById, TransportDetail } from 'src/tmc-yard/common/configuration/transport.configuration';
import { DataType } from 'src/tmc-yard/common/model/common.model';



@Component({
  selector: 'app-transport-overview',
  templateUrl: './transport-overview.component.html',
  styleUrls: ['./transport-overview.component.scss']
})
export class TransportOverviewComponent extends AbstractWidgetComponent implements OnInit, OnDestroy {

  SELECTED_TRANSPORTS_KEY = 'selected-transports';

  /* Make Enums available for template. */
  readonly TransportScope = TransportScope;
  readonly TransportTaskStatus = TransportTaskStatus;

  refreshEnabled = true;
  refreshInterval = 30000;
  refreshTimer: Subscription;

  lastTransportChangedTimestamp: number;

  sortEmptyValuestoEndForColumns: string[] = ['start'];
  sortDirection: SortDirection = 'asc' as SortDirection;
  sortColumn = 'start';

  transportCounts = new TransportCounts();

  data = new Array<Transport>();
  allTransports = new Array<Transport>();

  dataSource = new MatTableDataSource(new Array<Transport>());
  selection = new SelectionModel<Transport>(false);
  currentFilterSortDefinition: SortDefinition;

  selectedTransportId: number;

  transportSelection: TransportSelection;

  @ViewChild(MatSort, { static: true }) sort: MatSort;

  @ViewChildren(MatRow, { read: ElementRef }) tableRows: QueryList<ElementRef>;

  defaultVisibleColumns = [
    'hint', 'carrier', 'supplier', 'identifier',
    'name', 'visitStatusDict', 'currentStation', 'nextStation', 'string1', 'string2',
    'processingTime', 'waitingTime', 'start',
    'reference', 'options', 'cargo', 'planningDate', 'messagingResources',
    'currentPositionStatus', 'currentPositionStart', 'currentPositionStatusStart',
    'currentPositionDuration', 'currentPositionStatusDuration', 'registrationCode', 'currentPositionCargo', 'currentPositionHint',
    'processingTimeCurrentProcessing', 'beginReal', 'currentRoutingPositionOptionValues', 'nextProcessingPositionOptionValues', 'internal', 'filler'
  ];
  configuredVisibleColumns = this.configurationService.getClientParamValue(TMCClientParameters.P_VISITS_TRANSPORT_COLUMNS, null).split('|');
  columnsToDisplay = this.transportDetailsLayoutConverter.mapAttributes(this.configuredVisibleColumns != null ? this.configuredVisibleColumns : this.defaultVisibleColumns);

  widgetConfigurationFilterModel: TransportSelection;
  filterModel: TransportSelection;

  filterExternalKey: string;
  filterId: number;
  filter: CustomFilter;


  constructor(
    public translationService: TranslationService,
    private http: HttpService,
    private transportDetailsLayoutConverter: TransportDetailsLayoutConverter,
    private tmcContextService: TmcContextService,
    private configurationService: ConfigurationService,
    private commonBrowserStorageService: CommonBrowserStorageService,
    private clientContextService: ClientContextService,
    private dateUtilsService: DateUtilsService
  ) {
    super();


  }

  ngOnInit() {

    /* reload immer über ein Event auslösen um mehrfaches Auslösen in kurzer Zeit zu verhindern */
    this.transportListRealoadRequestSubject.pipe(debounceTime(300), switchMap(() => this.loadTransportsToList())).subscribe(() => { });

    if (this.widgetReference.data.filter != null) {
      this.filterExternalKey = this.widgetReference.data.filter;
      console.log('setting filter from widget definition', this.filterExternalKey);
      this.tmcContextService.updated.subscribe(config => {
        this.applyFilterDetails(false);
        this.requestTransportListReaload();
        this.restoreSelectedTransport();
      });
    } else {
      this.tmcContextService.yardConfigurationInitialized.subscribe(() => {
        this.applyFilterDetails(false);
        this.requestTransportListReaload();
        this.restoreSelectedTransport();
      });
    }


    this.registerRefreshTimer();

    // workaround => siehe Attributbeschreibung
    timer(2000).subscribe(() => { this.firstEventHack = true });

  }

  ngOnDestroy() {

    super.ngOnDestroy();

    if (this.refreshTimer) {
      this.refreshTimer.unsubscribe();
    }
  }

  public onTransportSelected(transport: Transport) {

    if (transport == null) {
      this.selectedTransportId = null;
    } else {
      this.selectedTransportId = transport.id;
    }

    this.storeSelectedTransport();
    this.checkAndNotifySelection();

  }

  public onTransportSelectionRequest(transportId: number) {

    this.selectedTransportId = transportId;

    this.storeSelectedTransport();
    this.checkAndNotifySelection();

  }

  private findTransportInData(id: number): Transport | null {
    for (const t of this.data) {
      if (t.id === this.selectedTransportId) {
        return t;
      }
    }
    return null;
  }

  private checkAndNotifySelection() {

    let transport = this.findTransportInData(this.selectedTransportId);
    if (transport == null) {
      return;
    }

    this.dashboardContext.setContextValue('selected-transport', transport);

  }

  private registerRefreshTimer() {

    if (this.refreshTimer) {
      this.refreshTimer.unsubscribe();
    }

    if (environment.autoreload && this.refreshEnabled) {
      this.refreshTimer = interval(this.refreshInterval).subscribe(() => {
        this.requestTransportListReaload();
      });
    } else {
      console.log('refresh timer for transport list disabled');
    }
  }

  private transportListRealoadRequestSubject = new Subject<null>();

  private loadTransportsToList(): Subject<boolean> {

    const identity = new TransportIdentity();
    identity.customFilterId = this.filter?.id;

    let result = new Subject<boolean>();

    // load transports from server
    this.http.postWithContext<Array<Transport>>(`${environment.transportOverviewEndpoint}/transports-neu`, identity).subscribe(
      response => {

        const allTransports = new Array<Transport>();
        for (const t of response) {
          allTransports.push(new Transport(t));
        }
        this.allTransports = allTransports;

        this.updateTableData();
        this.updateTotalCounts();
        this.checkAndNotifySelection()

        result.next(true);

      },
      error => {
        console.log('Error wihle Loading list of vists!', error);
        result.next(false);
      });

    return result;
  }

  private requestTransportListReaload() {
    this.transportListRealoadRequestSubject.next();
  }

  private applyFilterDetails(whileInitialization: boolean) {

    let filter: CustomFilter = null;
    this.tmcContextService.getYardConfiguration()?.customFilters.forEach(f => {
      if (f.id === this.filterId || f.externalKey === this.filterExternalKey) {
        filter = f;
      }
    });

    console.log('filter is', filter);
    this.filter = filter;

    // columns
    if (filter != null && filter.tableColumns != null && filter.tableColumns != '') {
      this.columnsToDisplay = this.transportDetailsLayoutConverter.mapAttributes(filter.tableColumns.split("|"));
    } else {
      this.columnsToDisplay = this.transportDetailsLayoutConverter.mapAttributes(this.configuredVisibleColumns != null ? this.configuredVisibleColumns : this.defaultVisibleColumns);
    }
    this.columnsToDisplay.push('filler');

    // default sort
    console.log('apply filter sort if false', whileInitialization);
    if (!whileInitialization) {
      console.log('applying filter sort', filter);
      if (filter != null) {
        this.currentFilterSortDefinition = new SortDefinition({ column: filter.sortColumn, direction: filter.sortDescending ? 'desc' : 'asc' });
      } else {
        this.currentFilterSortDefinition = null;
      }
    }

  }

  private updateTableData() {

    this.data = this.allTransports.filter(t => this.checkTransportForFilter(t));

    const autoselectEnabled = this.configurationService.isEnabled(
      TMCClientParameters.P_VISITS_TRANSPORT_AUTO_SELECT_SINGLE_SEARCH_RESULT, false);

    if (this.data.length === 1 && autoselectEnabled) {
      this.selectedTransportId = this.data[0].id;
      this.storeSelectedTransport();
    }

    this.checkAndNotifySelection();

  }

  private checkStatusIn(status: TransportStatus, checkStatus: Array<TransportStatus>): boolean {
    for (const statusToCheck of checkStatus) {
      if (statusToCheck === status) {
        return true;
      }
    }
    return false;
  }

  private updateTotalCounts() {
    let totalCount = this.data.length;
    let plannedCount = 0;
    let inProgressCount = 0;
    let waitingForPull = 0;
    let finishedCount = 0;
    let pausedCount = 0;
    let vehicles = 0;

    for (const r of this.data) {

      /* vehicles */
      if (r.masterdata.transportType === TransportType.VEHICLE) {
        vehicles += 1;
      }

      /* waiting for pull */
      else if (r.processing.waitingForPulling) {
        waitingForPull += 1;
      }

      /* planned */
      else if (this.checkStatusIn(r.processing.status, [TransportStatus.PLANNED, TransportStatus.IN_THE_INFLOW])) {
        plannedCount += 1;
      }

      /* in Processing */
      else if (this.checkStatusIn(r.processing.status, [TransportStatus.REGISTERED, TransportStatus.RETRIEVED, TransportStatus.WAITING])) {
        inProgressCount += 1;
      }

      /* in Processing */
      else if (this.checkStatusIn(r.processing.status, [TransportStatus.PAUSED])) {
        pausedCount += 1;
      }

      /* finished */
      else if (this.checkStatusIn(r.processing.status, [TransportStatus.COMPLETE, TransportStatus.FINISHED, TransportStatus.CANCELLED, TransportStatus.FINISHED_CANCELLED])) {
        finishedCount += 1;
      }

      /* no match */
      else {

        console.log('no matching sum check for status', r.processing.status);

      }
    }

    this.transportCounts = new TransportCounts({ total: totalCount, planned: plannedCount, finished: finishedCount, inProcessing: inProgressCount, paused: pausedCount, waitingForPull: waitingForPull, vehicles: vehicles });
  }

  /* die Initialisierung der Filter ist aktuell nicht zu erkennen, da sie außerhalb im Filter Widget passiert. Darum wird sich gemerkt ob der Filter ein erstes Mal gesetzt wird */
  firstEventHack: boolean = true;

  onContextChange(contextChange: ContextChange) {

    console.log('context changed', contextChange);

    if (contextChange.key === 'transport-selection') {
      const customFilterChanged = this.transportSelection?.customFilterId !== contextChange.value.customFilterId;
      this.transportSelection = new TransportSelection(contextChange.value);
      if (customFilterChanged) {
        this.filterId = this.transportSelection.customFilterId;
        console.log('setting filter from context', this.transportSelection, this.filterId);
        this.applyFilterDetails(this.firstEventHack);
        this.requestTransportListReaload();
      } else {
        this.updateTableData();
        this.updateTotalCounts();
      }

      // ab jetzt kann es nicht mehr das erste Event sein
      this.firstEventHack = false;
    }

    // TODO legacy code: die Selektion von außen kann nur per ID erfolgen => request transport selection
    // if (contextChange.key === 'selected-transport') {
    //   this.onTransportSelected(contextChange.value);
    // }

    if (contextChange.key === 'request-transport-selection') {
      console.log('transport selection requested', contextChange.value);
      this.onTransportSelectionRequest(contextChange.value);
    }

    if (contextChange.key === 'transport-changed') {
      if (this.lastTransportChangedTimestamp == null || this.lastTransportChangedTimestamp !== contextChange.value) {
        this.lastTransportChangedTimestamp = contextChange.value;
        this.requestTransportListReaload();
      }
    }

  }

  onSetElementAndContext() {

  }

  private checkTransportForFilter(transport: Transport): boolean {

    /* wenn scope gesetzt ist dann prüfen */
    if (this.transportSelection != null) {
      if (this.transportSelection.scopeTrain !== false || this.transportSelection.scopeTrailer !== false
        || this.transportSelection.scopeSwapTrailer !== false || this.transportSelection.scopeSemiTrailerTruck !== false) {

        if (
          (TransportScope.TRAIN === transport.masterdata.transportScope && !this.transportSelection.scopeTrain)
          || (TransportScope.TRAILER === transport.masterdata.transportScope && !this.transportSelection.scopeTrailer)
          || (TransportScope.SWAP_TRAILER === transport.masterdata.transportScope && !this.transportSelection.scopeSwapTrailer)
          || (TransportScope.SEMI_TRAILER_TRUCK === transport.masterdata.transportScope && !this.transportSelection.scopeSemiTrailerTruck)
        ) {
          return false;
        }
      }
    }

    /* inhalte prüfen, falls es einen Filterwert gibt */

    if (this.transportSelection == null || this.transportSelection.filterText == null || this.transportSelection.filterText.length == 0) {
      return true;
    }

    for (let columnId of this.columnsToDisplay) {

      let detail: TransportDetail = getTransportDetailById(columnId);

      if (detail != null) {
        let valueOrg = transport.getValueByPath(detail.attribute);
        if (valueOrg != null) {
          switch (detail.dataType) {

            case DataType.STRING:
              let value = valueOrg.toLowerCase();
              let queryLower = this.transportSelection.filterText.toLowerCase();
              if (value.indexOf(queryLower) > -1) {
                return true;
              }
              continue;


            case DataType.DATE:
              let formattedValue = this.dateUtilsService.formatTimestampToDeFormat(valueOrg, false);
              if (formattedValue.indexOf(this.transportSelection.filterText) > -1) {
                return true;
              }
              if (valueOrg.indexOf(this.transportSelection.filterText) > -1) {
                return true;
              }
              continue;


            case DataType.DICTIONARY:
            case DataType.DATA_DICTIONARY:
              let translatedValue = '';
              if (detail.dictionaryRoot != null && detail.dictionaryRoot !== '') {
                translatedValue = this.translationService.translate(detail.dictionaryRoot + valueOrg);
              } else {
                translatedValue = this.translationService.translate('dd.' + detail.dataDictionaryTable + '.' + valueOrg + '.' + detail.dataDictionaryAttribute);
              }
              if (translatedValue != null && translatedValue !== '') {
                let value = translatedValue.toLowerCase();
                let queryLower = this.transportSelection.filterText.toLowerCase();
                if (value.indexOf(queryLower) > -1) {
                  return true;
                }
              }
              continue;

            default:
              continue;
          }
        }
      }

    }

    return false;


  }



  restoreSelectedTransport() {
    const selectedTransportIds = JSON.parse(this.commonBrowserStorageService.get(this.clientContextService.getUnit().key, this.widgetIdentifier, this.SELECTED_TRANSPORTS_KEY));
    if (selectedTransportIds != null && selectedTransportIds.length > 0) {
      this.selectedTransportId = selectedTransportIds[0];
      this.checkAndNotifySelection();
    }
  }

  storeSelectedTransport() {
    this.commonBrowserStorageService.setPersistent(this.clientContextService.getUnit().key, this.widgetIdentifier, this.SELECTED_TRANSPORTS_KEY, JSON.stringify([this.selectedTransportId]));
  }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }

}
